const environment = {
  // apiURL: 'http://localhost:9197/api/v1'
  // apiURL: 'https://sabbath-school-app.serveo.net/api/v1'
  apiURL: "https://api.adventistas.app/api/v1",
};

export default environment;
